import React from 'react'

const Footer = () => {
  return (
    <div style={{textAlign:"center",marginBottom:10}}>Made by 😎 
        <a href='https://www.linkedin.com/in/hritick-kumar-jha-4b238a200/' style={{cursor:"pointer"}}> Hritick</a>
    </div>
  )
}

export default Footer